import { useSlots as _useSlots, defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "c-slideInObject" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "content__head" }
const _hoisted_4 = { class: "content__header" }
const _hoisted_5 = { class: "content__body" }
const _hoisted_6 = {
  key: 0,
  class: "content__footer"
}
const _hoisted_7 = {
  key: 0,
  class: "context"
}

import { computed, ref, watch } from 'vue';
import BackIcon from '@web/assets/icon/btnArrow.svg';

// Define slot

export default /*@__PURE__*/_defineComponent({
  __name: 'SlideInObject',
  props: {
  isOpen: {
    type: Boolean,
    default: false,
  },
  placement: {
    type: String,
    default: 'right',
  },
},
  emits: ['close'],
  setup(__props, { emit: __emit }) {

const slot = _useSlots();

// Define emit
const emit = __emit;

// Define prop
const props = __props;

// Define slideIn Animation
const slideInAnimation = computed(() => 'slide-' + props.placement);

// Define placement class
const placementClass = computed(
  () => 'c-slideInObject__main--' + props.placement
);

watch(
  () => props.isOpen,
  () => {
    if (props.isOpen) {
      document.body.classList.add('scroll-lock');
      return;
    }

    document.body.classList.remove('scroll-lock');
  }
);

// Close function
function close() {
  // If context exists and value is true, close context
  if (slot.context && isContext.value) {
    isContext.value = false;
    return;
  }

  // emit the close function
  emit('close');
}

// Defines if context is open
const isContext = ref(false);

// Handle opening of context
function handleContext() {
  // If context exists, set timeout to open context
  if (slot.context) {
    setTimeout(() => {
      isContext.value = true;
    }, 150);
    return;
  }

  // Make sure context is closed
  isContext.value = false;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (props.isOpen)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "c-slideInObject__background",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (close()))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, {
      name: slideInAnimation.value,
      onAfterEnter: handleContext
    }, {
      default: _withCtx(() => [
        (props.isOpen)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["c-slideInObject__main", placementClass.value])
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", {
                    class: "close",
                    onClick: close
                  }, [
                    _createVNode(_unref(BackIcon)),
                    _cache[1] || (_cache[1] = _createElementVNode("span", { class: "close__heading" }, "Tilbage", -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _renderSlot(_ctx.$slots, "header")
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _renderSlot(_ctx.$slots, "body")
                ]),
                (_ctx.$slots.footer)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _renderSlot(_ctx.$slots, "footer")
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_Transition, {
                name: slideInAnimation.value,
                onLeave: close
              }, {
                default: _withCtx(() => [
                  (_ctx.$slots.context && isContext.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "context__seperator" }, null, -1)),
                        _renderSlot(_ctx.$slots, "context")
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 3
              }, 8, ["name"])
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _: 3
    }, 8, ["name"])
  ]))
}
}

})